import React, {useState, useEffect, useContext} from "react";
import {functions} from "../../constants/common-functions";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import AmChartPie from "../../components/AmChartPie";
import DashboardToolPanel from "../../components/DashboardToolPanel";
import ChartCard from "../../components/ChartCard";
import ChartCardLarge from "../../components/ChartCardLarge";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import {store} from '../../context/store';

export default function UtilisationBreakdownBySpaceType(){
	
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const [data3, setData3] = useState([]);
	const [data4, setData4] = useState([]);
	
	const [loaded, setLoaded] = useState(false);
	const [displaySpaceType, setDisplaySpaceType] = useState("flex");
	const [displayOrganisation, setDisplayOrganisation] = useState("none");
	
	const globalState = useContext(store);
	
	const queryContext =
				    globalState?.state?.queryContext;
	
	useEffect(() => {
		if(loaded === false){
			setLoaded(true);
		}
	
		loadData();
		
	}, [queryContext]);
	
	
	const loadData = () => {
		functions.postFilterBeanAjax(
			"/resolutionsoftwareplatform/dashboard/utilisation/filter/breakdown",
			functions.buildPostBodyFilterBeanQueryContext({}, queryContext),
			handleData
		);
	};
	
	const handleData = (obj) => {
		console.log(obj);
		try{
		  const tempData1 = obj.resultsParentSpaceType.map(({ id, name, value}) => ({
		    id,
		    label: name,
		    value
		  }));
		  setData1(tempData1);
		  
		  const tempData2 = obj.resultsSpaceType.map(({ id, name, value}) => ({
		    id,
		    label: name,
		    value
		  }));
		  setData2(tempData2);
		  
		  const tempData3 = obj.resultsParentOrganisation.map(({ id, name, value}) => ({
		    id,
		    label: name,
		    value
		  }));
		  setData3(tempData3);
		  
		  const tempData4 = obj.resultsOrganisation.map(({ id, name, value}) => ({
		    id,
		    label: name,
		    value
		  }));
		  setData4(tempData4);
		  
		}
		catch(e){}
	};
	
	
	const refreshFunction = () => {
		loadData();
	};
	
	const showSpaceTypeChart = () => {
		setDisplaySpaceType("flex");
		setDisplayOrganisation("none");
	};
	
	const showOrganisationChart = () => {
		setDisplaySpaceType("none");
		setDisplayOrganisation("flex");
	};

	
	const toolActions =[
		{label:'Space Type', actionFunction:showSpaceTypeChart},
		{label:'Organisation', actionFunction:showOrganisationChart}
	];
 	
	return (
	
		  <UtilityDashboardLayout
		    title="Utilisation By Space Type/Organisation"
		    childDashboards={childDashboardsUtilisation}
		    refreshFunction={refreshFunction}
		  >

			<div style={{...utilityDashboardComponentContainer, display:displaySpaceType}}>
			  <ChartCardLarge title="Primary Space Type">
			    <AmChartPie
			      chartData={data1}
			      categoryKey="label"
			      valueKey="value"
			      width="90%"
			      height="90%"
			      chartId="utilisationbreakdownbyspacetypechart1"
			      keyPosition="right"
			    />
			  </ChartCardLarge>
			</div>
			<div style={{...utilityDashboardComponentContainer, display:displaySpaceType}}>
			  <ChartCardLarge title="Secondary Space Type">
			  <AmChartPie
			  										chartData={data2}
			  										categoryKey="label"
			  										valueKey="value"
			  										width="90%"
			  										height="90%"
			  										chartId="utilisationbreakdownbyspacetypechart2"
			  										keyPosition="right"
			  									/>
			  </ChartCardLarge>
			</div>
			<div style={{...utilityDashboardComponentContainer, display:displayOrganisation}}>
			  <ChartCardLarge title="Primary Organisation">
			  <AmChartPie
					chartData={data3}
					categoryKey="label"
					valueKey="value"
					width="90%"
					height="90%"
					chartId="utilisationbreakdownbyspacetypechart3"
					keyPosition="right"
				/>
			  </ChartCardLarge>
			</div>
			<div style={{...utilityDashboardComponentContainer, display:displayOrganisation}}>
			  <ChartCardLarge title="Secondary Organisation">
			  <AmChartPie
					chartData={data4}
					categoryKey="label"
					valueKey="value"
					width="90%"
					height="90%"
					chartId="utilisationbreakdownbyspacetypechart4"
					keyPosition="right"
				/>
			  </ChartCardLarge>
			</div>	
				
			<DashboardToolPanel
				title="Show Charts"
				actions={toolActions}
			/>
			
		  </UtilityDashboardLayout>
		);
}